import CustomModal from "../../../../../components/Modal/CustomModal";
import React, {useState} from "react";
import DivContainerBody from "../../../../../components/DivContainerBody";
import {Box} from "@mui/material";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {UpdateAccessComment} from "../../../../../reduxToolkit/Logs/LogApi";
import {useDispatch} from "react-redux";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 12 de 05 de 2026
 */

const AccessReportModal = (props) => {
    const {data,t,onHide} = props
    const [itemComment, setItemComment] = useState(null);
    const [emptyFields, setEmptyFields] = useState(false);
    const dispatch = useDispatch();

    /**
     * Handles access report creation.
     *
     * Prevents submission when the comment is empty.
     *
     * @returns {void}
     */
    const handleReport = (id) => {
        const comment = itemComment?.trim();
        if (!comment) {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);
        const body = {id, comment};

        dispatch(UpdateAccessComment(body));

        onHide();
        setItemComment('')
    };

    return (
        <>
            <CustomModal
                {...props}
                buttonConfirm="confirm"
                size={'md'}
                cancelButton={true}
                confirmButton={true}
                title={"report_access"}
                onConfirm={() => {
                    handleReport(data?.accessId);
                }}
                classNameBody="pt-2"
            >
                <DivContainerBody>
                    <div className={"d-flex flex-column gap-2 justify-content-center align-items-center align-content-center"}>
                        <p className="font-color-shades-950 ibl-font-w-600 fs-14px">{t('are_you_sure_to_proceed')}</p>
                        <p className="font-color-general-950 ibl-font-w-600 fs-14px">{t('please_provide_required_information')}</p>
                    </div>
                    <Box className='col-12 p-0 mt-3'>
                        <CustomTextField
                            id={"txt_arm_instruction"}
                            length={500}
                            name={"comment"}
                            value={itemComment}
                            trans={"comment"}
                            type={"text"}
                            onChange={(e) => setItemComment(e.target.value)} // Update instructions
                            required={true}
                            emptyFields={emptyFields}
                            multiline={true}
                        />
                    </Box>
                </DivContainerBody>
            </CustomModal>
        </>
    )
}

export default AccessReportModal
